import React, { useState } from 'react'
import { connect } from 'react-redux'
import { setActiveTab } from '../../actions'
import toJS from '../general/toJS'
import { HashLink as Link } from 'react-router-hash-link';
import ImagesAccordion from '../../components/forms/fields/movie-data/ImagesAccordion';
import PlaytimesAccordion from '../../components/forms/fields/movie-data/PlaytimesAccordion'
import InformationAccordion from '../../components/forms/fields/movie-data/InformationAccordion'
import {
    INFORMATION,
    IMAGES,
    PLAYTIMES,
    ATTRIBUTES
} from '../../constants/tabTypes'
import AttributesAccordion from '../../components/forms/fields/movie-data/AttributesAccordion';
import { CLI_CINEMA_CLIENT_ID, CLI_MULTICINEMA_MODE, PROGRAM_CINEMAS, ROUTES_DATA, TRANSLATION } from '../../constants/state'
import getData from '../../functions/getData';


const mapDispatchToProps = (dispatch, ownProps) => ({
    setActiveTab: (activeClass, id) => {
        if(activeClass !== "accordion-item-open") {
            dispatch(setActiveTab(id))
        }
    },
})

const mapStateToProps = (state, ownProps) => ({
    // activeTab: state.getIn(['ui', 'program', 'activeTab']),
    cliCinemas: getData(state, PROGRAM_CINEMAS),
    clientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID)
})

const FormMovieDataTabContainer = ({tabs, setFieldValue, values, activeSelectionAccordionValue, handleChange, cliCinemas, clientCinemaId, metaData, setMovieImages, onChange, onReset}) => {
    const [activeTab, setActiveTab] = useState('information')
    const titleOnClick = (activeTabClass, id) => {
        if(!activeSelectionAccordionValue) {
            if(activeTabClass !== "accordion-item-open") {
                setActiveTab(id)
            }
        } else {
            editSelection(false)
            if(activeTabClass !== "accordion-item-open") {
                setActiveTab(id)
            }
        }
    }

    let formTabContainer = [];
    let formTabs = [];

    let hasCountdownMovie = false
    const movieCinemaPks = values.movie.cinemaIds
    movieCinemaPks.map(cinemaPk => {
        const cinema = cliCinemas[cinemaPk] 
        const cinemaDataProvider = cinema ? cinema.scope.cinemaDataProvider.type : null

        hasCountdownMovie = cinemaDataProvider ? cinemaDataProvider === 'compeso' || cinemaDataProvider === 'dieselV2' ? true : false : false        
    })

    
    tabs.map(tab => {
        const activeTabClass = activeTab === tab.id ? "accordion-item-open" : "accordion-item-close"
        let tabContent

        formTabs.push(
            <div key={tab.id} className={"selections-item header-" + activeTabClass}>
                <h3 className="selections-item-title accordion-header site-content-wrapper-inner title-large-light" onClick={() => titleOnClick(activeTabClass, tab.id)}>
                    <Link to={"#" + tab.id}><span>{tab.title}</span></Link>
                </h3>
            </div>
        )

        if(tab.id === INFORMATION) {    
            tabContent = (
                <InformationAccordion
                    key={INFORMATION}
                    classes={"information single-section"}
                    values={values}
                    activeTabClass={activeTabClass}
                    setFieldValue={setFieldValue}
                    setActiveTab={setActiveTab}
                    metaData={metaData}
                    hasCountdownMovie={hasCountdownMovie}
                    onChange={onChange}
                    onReset={onReset}
                />
            )
        } else if(tab.id === ATTRIBUTES) {
            tabContent = (
                <AttributesAccordion
                    key={ATTRIBUTES}
                    classes={"attributes single-section"}
                    values={values}
                    activeTab={activeTab}
                    clientCinemaId={clientCinemaId}
                    activeTabClass={activeTabClass}
                    setActiveTab={setActiveTab}
                    setFieldValue={setFieldValue}
                    cliCinemas={cliCinemas}
                    />
                    )
        } else if(tab.id === PLAYTIMES) {
            tabContent = (
                <PlaytimesAccordion
                    key={PLAYTIMES}
                    classes={"playtimes single-section"}
                    values={values}
                    clientCinemaId={clientCinemaId}
                    activeTab={activeTab}
                    activeTabClass={activeTabClass}
                    setActiveTab={setActiveTab}
                    setFieldValue={handleChange}
                    cliCinemas={cliCinemas}
                />
            )
        } else if(tab.id === IMAGES) {
            tabContent = (
                <ImagesAccordion
                    key={IMAGES}
                    classes={"images single-section"}
                    values={values}
                    activeTab={activeTab}
                    activeTabClass={activeTabClass}
                    setActiveTab={setActiveTab}
                    setMovieImages={setMovieImages}
                />
            )
        }

        formTabContainer.push(tabContent)
    })

    return (
        <div>
            <div className="standalone-tabs">
                {formTabs}
            </div>
            {formTabContainer}
        </div>
    )
}

export default connect(mapStateToProps, () => ({}))(connect(mapStateToProps, mapDispatchToProps)(toJS(FormMovieDataTabContainer)))